const cleanLocationText = (value) => String(value ?? '')
    .trim()
    .replace(/\s+/g, ' ');

const normalizeLocationText = (value) => cleanLocationText(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

export const getLocationPlaceName = (location) => cleanLocationText(
    location?.place_name ?? location?.placeName,
);

export const getLocationAddress = (location, fallback = '') => [
    location?.address,
    location?.description,
    fallback,
].map(cleanLocationText).find(Boolean) ?? '';

export const formatLocationDisplay = (location, fallback = '') => {
    const placeName = getLocationPlaceName(location);
    const address = getLocationAddress(location, fallback);

    if (!placeName) return address;
    if (!address) return placeName;

    const firstAddressPart = address.split(',')[0];
    if (normalizeLocationText(firstAddressPart) === normalizeLocationText(placeName)) {
        return address;
    }

    return `${placeName}, ${address}`;
};

const getPickupScalarAddress = (pickup, kind) => kind === 'origin'
    ? pickup?.origin_address ?? pickup?.pickup_origin_address
    : pickup?.dropoff_address ?? pickup?.pickup_dropoff_address;

const getPickupScalarPlaceName = (pickup, kind) => kind === 'origin'
    ? pickup?.origin_place_name ?? pickup?.pickup_origin_place_name
    : pickup?.dropoff_place_name ?? pickup?.pickup_dropoff_place_name;

const getPickupLocations = (pickup, kind) => {
    const locations = kind === 'origin' ? pickup?.origins : pickup?.dropoffs;
    if (Array.isArray(locations) && locations.length > 0) return locations;

    const singleLocation = kind === 'origin' ? pickup?.origin : pickup?.dropoff;
    return singleLocation ? [singleLocation] : [];
};

export const formatPickupLocationDisplay = (pickup, kind) => {
    const fallback = getPickupScalarAddress(pickup, kind);
    const scalarPlaceName = getPickupScalarPlaceName(pickup, kind);
    const locations = getPickupLocations(pickup, kind);
    const normalizedFallback = normalizeLocationText(fallback);
    const matchingLocation = normalizedFallback
        ? locations.find((location) => (
            normalizeLocationText(getLocationAddress(location)) === normalizedFallback
        ))
        : null;
    const defaultLocation = kind === 'dropoff'
        ? locations[locations.length - 1]
        : locations[0];
    const selectedLocation = matchingLocation ?? defaultLocation;
    const displayLocation = selectedLocation || scalarPlaceName
        ? {
            ...selectedLocation,
            place_name: getLocationPlaceName(selectedLocation) || scalarPlaceName,
        }
        : null;

    return formatLocationDisplay(displayLocation, fallback);
};

export const formatPickupOriginDisplay = (pickup) => (
    formatPickupLocationDisplay(pickup, 'origin')
);

export const formatPickupDropoffDisplay = (pickup) => (
    formatPickupLocationDisplay(pickup, 'dropoff')
);
